<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Users</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Users"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox
                            label="Active Only"
                            v-model="activeOnly"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn
                            color="success"
                            block
                            @click="editUser()"
                        >
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="users"
                            :loading="loading"
                            :search="search"
                            hide-actions
                            must-sort
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.Email}}</td>
                                    <td>{{props.item.FirstName}}</td>
                                    <td>{{props.item.LastName}}</td>
                                    <td>{{formatStoresList(props.item.Stores)}}</td>
                                    <td>{{formatDepartmentsList(props.item.Departments)}}</td>
                                    <td v-if="props.item.Permissions.access"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Permissions.access"><v-icon color="error">close</v-icon></td>
                                    <td v-if="props.item.Permissions.order"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Permissions.order"><v-icon color="error">close</v-icon></td>
                                    <td v-if="props.item.Permissions.report"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Permissions.report"><v-icon color="error">close</v-icon></td>
                                    <td v-if="props.item.Permissions.assignsuppliers"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Permissions.assignsuppliers"><v-icon color="error">close</v-icon></td>
                                    <td v-if="props.item.Permissions.managedata"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Permissions.managedata"><v-icon color="error">close</v-icon></td>
                                    <td v-if="props.item.Permissions.manageusers"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Permissions.manageusers"><v-icon color="error">close</v-icon></td>
                                    <td v-if="props.item.Permissions.admin"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Permissions.admin"><v-icon color="error">close</v-icon></td>
                                    <td>
                                        <v-btn
                                            v-if="canEdit(props.item)"
                                            color="warning"
                                            block
                                            @click="editUser(props.item)"
                                        >
                                            Edit
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="saving" @click="cancelEditUser">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title v-if="editedUser && editedUser.fromDB">Edit User</v-toolbar-title>
                        <v-toolbar-title v-else>Add New User</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form ref="editForm" v-model="editUserValid">
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12 v-if="editedUser.ADObjectID">
                                        <v-alert
                                          v-model="infoVisible"
                                          outline
                                          dismissible
                                          type="info">
                                          Some fields cannot be changed as this user has been linked to an Active Directory account.
                                        </v-alert>
                                    </v-flex>
                                    <v-flex xs12 v-if="!editedUser.ADObjectID">
                                        <v-text-field
                                            clearable
                                            counter="100"
                                            maxlength="100"
                                            v-model="editedUser.Email"
                                            :rules="[rules.required, rules.email]"
                                            label="User Email">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="editedUser.ADObjectID">
                                        <v-text-field
                                            v-model="editedUser.Email"
                                            :readonly="true"
                                            label="User Email"
                                            append-icon="info"
                                            @click:append="showInfo">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="editedUser.FirstName">
                                        <v-text-field
                                            v-model="editedUser.FirstName"
                                            :readonly="true"
                                            label="First Name"
                                            append-icon="info"
                                            @click:append="showInfo">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="editedUser.LastName">
                                        <v-text-field
                                            v-model="editedUser.LastName"
                                            :readonly="true"
                                            label="Last Name"
                                            append-icon="info"
                                            @click:append="showInfo">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.phoneNumber]"
                                            :mask="phoneMask(editedUser.PhoneNumber)"
                                            v-model="editedUser.PhoneNumber" 
                                            label="User Phone Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.phoneNumber]"
                                            :mask="phoneMask(editedUser.MobileNumber)"
                                            v-model="editedUser.MobileNumber" 
                                            label="User Mobile Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            :items="stores"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="editedUser.Stores"
                                            label="Stores"
                                            multiple
                                            chips
                                            hint="Stores"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            :items="departments"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="editedUser.Departments"
                                            label="Departments"
                                            multiple
                                            chips
                                            hint="Departments"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-layout wrap>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Active" v-model="editedUser.Permissions.access"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to access the site once logged in.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Ordering" v-model="editedUser.Permissions.order"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to make new orders and view existing orders for the stores and departments that they have access to.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Reports" v-model="editedUser.Permissions.report"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to view the reports.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Assign Suppliers" v-model="editedUser.Permissions.assignsuppliers"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to assign suppliers to products for any stores that they have access to.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Manage Data" v-model="editedUser.Permissions.managedata"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to view and modify store, department, product, category and supplier data.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Manage Users" v-model="editedUser.Permissions.manageusers"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to view and modify users (excl. admin rights).</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Admin" v-model="editedUser.Permissions.admin" :disabled="!canEditAdminPermission"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to perform all system functionality (incl. banking details) for all stores and departments.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Banking Details Audit - John Chapley Group" v-model="editedUser.Permissions.bankingdetailsaudit_johnchapleygroup"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to view the banking details for John Chapley Group.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Banking Details Audit - CGMS" v-model="editedUser.Permissions.bankingdetailsaudit_sbd"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to view the banking details for CGMS.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Banking Details Audit - CRG" v-model="editedUser.Permissions.bankingdetailsaudit_crg"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to view the banking details for CRG.</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4>
                                                <v-checkbox label="Banking Details Audit - Supplier Audit" v-model="editedUser.Permissions.bankingdetailsaudit_cg"></v-checkbox>
                                                <p class="permission-explainer">Allows the user to view the banking details for Supplier Audit.</p>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="error" :disabled="saving" @click="cancelEditUser">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!editUserValid" :loading="saving" @click="saveEditedUser">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <error-alert :content="saveError" :display="saveError"></error-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert"
import auth from '@/services/auth';

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            infoVisible: false,
            editedUser: {
                Permissions: {},
                Stores: [],
                Departments: []
            },
            showEditDialog: false,
            editUserValid: false,
            search: "",
            activeOnly: true,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Email",
                    value: "Email"
                },
                {
                    text: "First Name",
                    value: "FirstName"
                },
                {
                    text: "Last Name",
                    value: "LastName"
                },
                {
                    text: "Stores",
                    value: "Stores",
                    sortable: false
                },
                {
                    text: "Departments",
                    value: "Departments",
                    sortable: false
                },
                {
                    text: "Active",
                    value: "Permissions.access"
                },
                {
                    text: "Ordering",
                    value: "Permissions.order"
                },
                {
                    text: "Reports",
                    value: "Permissions.report"
                },
                {
                    text: "Assign Suppliers",
                    value: "Permissions.assignsuppliers"
                },
                {
                    text: "Manage Data",
                    value: "Permissions.managedata"
                },
                {
                    text: "Manage Users",
                    value: "Permissions.manageusers"
                },
                {
                    text: "Admin",
                    value: "Permissions.admin"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.userStore.loading
            || this.$store.state.storeStore.loading 
            || this.$store.state.departmentStore.loading;
        },
        loadError() {
            return this.$store.state.userStore.loadError;
        },
        saving() {
            return this.$store.state.userStore.saving;
        },
        saveError() {
            return this.$store.state.userStore.saveError;
        },
        users() {
            return this.$store.state.userStore.users.filter(u => (u.Permissions && u.Permissions.access) || !this.activeOnly);
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active || !this.activeOnly);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active || !this.activeOnly);
        },
        canEditAdminPermission(){
            return auth.hasPermissions(["admin"]);
        }
    },
    methods: {
        showInfo(){
            this.infoVisible = true;
        },
        phoneMask(value) {
            return validationRules.phoneMask(value);
        },
        loadUsers() {
            this.$store.dispatch("userStore/loadUsers");
        },
        editUser(item) {
            // show which fields are mandatory when opening the edit form
            this.$refs.editForm.validate();
            
            this.editedUser = Object.assign({
                Permissions: {},
                Stores: [],
                Departments: []
            }, item);
            this.editedUser.fromDB = true;

            this.showEditDialog = true;
        },
        cancelEditUser() {
            this.showEditDialog = false;
            this.editedUser = {
                Permissions: {}
            };
        },
        saveEditedUser() {
            var that = this;

            this.$store.dispatch("userStore/saveUser", {
                user: this.editedUser,
                finally: function() {
                    if (that.$store.state.userStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditUser();
                    }
                }
            });
        },
        formatPhoneNumber(value) {
            return formatters.formatPhoneNumber(value);
        },
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        },
        formatStoresList(storeIds){
            if(!storeIds){
                return;
            }

            let formatted = "";

            for(let i = 0; i < storeIds.length; i++){
                let store = this.stores.find(s => s.ID == storeIds[i]);
                if(!store){
                    continue;
                }

                if(formatted.length > 0){
                    formatted += ", ";
                }
                formatted += store.Name;
            }

            return formatted;
        },
        formatDepartmentsList(departmentIds){
            if(!departmentIds){
                return;
            }

            let formatted = "";

            for(let i = 0; i < departmentIds.length; i++){
                let department = this.departments.find(d => d.ID == departmentIds[i]);
                if(!department){
                    continue;
                }

                if(formatted.length > 0){
                    formatted += ", ";
                }
                formatted += department.Name;
            }

            return formatted;
        },
        canEdit(item){
            let loggedInUser = this.$store.getters["authStore/getUserProfile"];
            if(loggedInUser.Email == item.Email){
                return false;
            }

            return true;
        }
    },
    created() {
        this.loadUsers();
        this.loadStores();
        this.loadDepartments();
    }
};
</script>

<style>
    
</style>